import Promise from 'promise-polyfill';

import getConfig from './get-config/get-config';
import exposeMethods from './expose-methods/expose-methods';
import { error as logError } from '../shared/logger';

import { loadDependencies, loadResources, loadScript, loadStyle } from './load/load';

function init({ elementId, treeId, personId, flowId, hintId, eventType, renderer, sourceGid }, configOverrides) {
	const config = getConfig(renderer, configOverrides);

	const urls = {
		css: `${config.hintsUiEvalCdnUrl}/app.css`,
		app: `${config.hintsUiEvalCdnUrl}/app.js`,
		resources: `${config.hintsUiEvalCdnUrl}/resources/resources.${config.locale}.json`
	};

	return loadDependencies(config).then(() => {
		return Promise.all([
			loadStyle(urls.css),
			loadScript(urls.app),
			loadResources(urls.resources)
		]).then(response => {
			const { hintsEval } = window;
			const options = {
				elementId,
				flowId,
				hintId,
				treeId,
				personId,
				sourceGid,
				config,
				resources: response[2],
				renderer
			};
			if (eventType) {
				options.eventType = eventType.toLowerCase();
			}
			const app = hintsEval.createApp(options);
			if (!Object.hasOwnProperty.call(hintsEval, 'instances')) {
				hintsEval.instances = {};
			}
			hintsEval.instances[elementId] = app;
			Object.assign(hintsEval, exposeMethods(hintsEval.instances));
		}).catch(logError);
	}).catch(logError);
}

export default init;
